{
  "addSupplier": {
    "stepper": {
      "title": "Agregar proveedor",
      "steps": {
        "generalInfo": {
          "title": "Información general",
          "description": "Ingrese la información general del proveedor"
        },
        "riskAssessment": {
          "title": "Evaluación de riesgos",
          "description": "Seleccione el nivel de riesgo del proveedor"
        },
        "supportingDocuments": {
          "title": "Documentos de respaldo",
          "description": "Cargue o vincule la documentación requerida"
        },
        "approval": {
          "title": "Aprobación",
          "description": "Verifique toda la información y envíe el proveedor para su aprobación"
        }
      },
      "buttons": {
        "saveAsDraft": "Guardar como borrador y salir",
        "cancel": "Cancelar",
        "previous": "Anterior",
        "next": "Siguiente",
        "sendForApproval": "Enviar para aprobación"
      }
    },
    "generalInfo": {
      "heading": "Información general",
      "fields": {
        "supplierName": {
          "label": "Nombre del proveedor*",
          "helper": "Este campo es obligatorio al enviar para aprobación."
        },
        "supplierType": {
          "label": "Tipo de proveedor",
          "helper": "Este campo es obligatorio al enviar para aprobación."
        },
        "website": {
          "label": "Sitio web"
        },
        "intendedUse": {
          "label": "Uso previsto"
        },
        "sponsor": {
          "label": "Patrocinador",
          "helper": "Este campo es obligatorio al enviar para aprobación."
        }
      },
      "contactInfo": {
        "heading": "Información de contacto del proveedor",
        "fields": {
          "name": "Nombre",
          "email": "Correo electrónico",
          "phone": "Teléfono",
          "address": "Dirección",
          "notes": "Notas"
        }
      },
      "warnings": {
        "invalidFields": "Parece que hay algunos campos con valores no válidos."
      }
    },
    "riskAssessment": {
      "heading": "Evaluación de riesgos",
      "description": "Los niveles de riesgo se definen en la política de proveedores. Si no está seguro ahora, puede volver a esto más tarde. Tenga en cuenta que el nivel de riesgo es necesario para asignar los documentos de respaldo correctos según lo exige la política."
    },
    "supportingDocuments": {
      "heading": "Documentos de respaldo",
      "alerts": {
        "selectTypeAndRisk": "Seleccione el tipo de proveedor y el nivel de riesgo para ver qué documentos son obligatorios.",
        "noMandatoryDocuments": "Su política de proveedores no requiere ningún documento obligatorio para el tipo de proveedor {{type}} y el nivel de riesgo {{level}}.",
        "documentsMovedTitle": "Documentos movidos a \"Documentos adicionales\"",
        "documentsMovedDescription": "Cada nivel de riesgo puede requerir documentos diferentes. Debido a que se cambió el nivel de riesgo, todos los documentos se han movido a \"Documentos adicionales\". Para volver a utilizarlos, descárguelos y agréguelos a los documentos requeridos. Estos cambios surtirán efecto cuando guarde al proveedor."
      },
      "policyText": "Su política de proveedores requiere los siguientes documentos para el tipo de proveedor {{type}} y el nivel de riesgo {{level}}.",
      "additionalDocumentsInfo": "Incluya cualquier documentación adicional que sea relevante para este proveedor."
    },
    "approval": {
      "heading": "Aprobación",
      "infoText": "Revise la información del proveedor antes de enviarla para su aprobación.",
      "sections": {
        "generalInformation": "Información general",
        "supplierContactInformation": "Información de contacto del proveedor",
        "riskLevel": "Nivel de riesgo",
        "supportingDocuments": "Documentos de respaldo",
        "additionalDocuments": "Documentos adicionales",
        "requiredAudits": "Auditorías requeridas",
        "approval": "Aprobación"
      },
      "fields": {
        "supplierName": "Nombre del proveedor",
        "supplierType": "Tipo de proveedor",
        "website": "Sitio web",
        "intendedUse": "Uso previsto",
        "sponsor": "Patrocinador",
        "name": "Nombre",
        "email": "Correo electrónico",
        "phone": "Teléfono",
        "address": "Dirección",
        "notes": "Notas",
        "approvers": "Aprobadores"
      },
      "messages": {
        "noMandatoryDocuments": "No hay documentos obligatorios",
        "noAdditionalDocuments": "No hay documentos adicionales",
        "requiredAuditsPolicy": "Para el tipo de proveedor {{type}} y el nivel de riesgo {{level}}, su política de proveedores requiere estas auditorías",
        "noRequiredAuditsPolicy": "Para el tipo de proveedor {{type}} y el nivel de riesgo {{level}}, su política de proveedores no requiere ninguna auditoría obligatoria",
        "auditFrequency": "Cada {{count}} mes(es)",
        "auditOnce": "Solo una vez",
        "approvalInfo": "Seleccione a las personas que pueden aprobar este proveedor. Se debe seleccionar al menos un usuario de calidad. Solo los usuarios con acceso a proveedores pueden ser seleccionados como aprobadores. La aprobación se otorgará cuando todos ellos acepten.",
        "auditReviewWarning": "Si se necesita una revisión de las auditorías antes de la aprobación, puede guardar este proveedor y agregar la auditoría y todos sus documentos en la sección \"Auditorías\" de este proveedor."
      },
      "warnings": {
        "requiredFieldsMissing": "Parece que faltan algunos campos obligatorios o hay campos con valores no válidos"
      },
      "supplierPolicyLink": "política de proveedores"
    },
    "modals": {
      "discardChanges": {
        "title": "Descartar cambios",
        "message": "¿Está seguro de que desea descartar los cambios en este proveedor? También puede guardarlo como borrador y terminarlo más tarde.",
        "buttons": {
          "cancel": "Cancelar",
          "saveAsDraft": "Guardar como borrador",
          "discardChanges": "Descartar cambios"
        }
      },
      "cantSaveSupplier": {
        "title": "No se puede guardar el proveedor",
        "message": "Para guardar este proveedor, debe asignarle un nombre.",
        "button": "Entendido"
      },
      "changeSupplierType": {
        "title": "¿Cambiar tipo de proveedor?",
        "message": "Cada nivel de riesgo puede requerir documentos diferentes. Todos los documentos se moverán a \"Documentos adicionales\" cuando guarde al proveedor.",
        "buttons": {
          "cancel": "Cancelar",
          "change": "Cambiar tipo de proveedor"
        }
      },
      "changeRiskLevel": {
        "title": "¿Cambiar nivel de riesgo?",
        "message": "Cada nivel de riesgo puede requerir documentos diferentes. Todos los documentos se moverán a \"Documentos adicionales\" cuando guarde al proveedor.",
        "buttons": {
          "cancel": "Cancelar",
          "change": "Cambiar nivel de riesgo"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "Por favor, ingrese un nombre de proveedor",
        "supplierNameEmpty": "El nombre del proveedor no puede estar vacío",
        "supplierNameTooLong": "El nombre del proveedor no puede tener más de 350 caracteres",
        "supplierTypeRequired": "Por favor, seleccione un tipo de proveedor",
        "intendedUseTooLong": "El campo Uso previsto no puede tener más de 4000 caracteres",
        "sponsorRequired": "Por favor, seleccione un patrocinador",
        "contactNotesTooLong": "El campo Notas de contacto no puede tener más de 4500 caracteres",
        "riskTypeRequired": "Por favor, seleccione un tipo de riesgo",
        "documentsRequired": "Se requiere al menos 1 documento de respaldo para: {{documentNames}}",
        "approversRequired": "Se deben seleccionar aprobadores",
        "qualityUserRequired": "Los aprobadores deben incluir al menos un usuario de calidad"
      },
      "fieldNames": {
        "name": "Nombre",
        "approvers": "Aprobadores",
        "contactAddress": "Dirección de contacto",
        "contactEmail": "Correo electrónico de contacto",
        "contactName": "Nombre de contacto",
        "contactNotes": "Notas de contacto",
        "contactPhone": "Teléfono de contacto",
        "documents": "Documentos",
        "intendedUse": "Uso previsto",
        "riskType": "Tipo de riesgo",
        "sponsor": "Patrocinador",
        "supplierType": "Tipo de proveedor",
        "website": "Sitio web"
      }
    }
  },
  "supplierList": {
    "heading": "Proveedores",
    "buttons": {
      "addSupplier": "Agregar proveedor",
      "import": "Importar",
      "exportAsl": "Exportar ASL",
      "exportCurrentView": "Exportar vista actual a CSV",
      "exportFullView": "Exportar vista completa a XLSX"
    },
    "search": {
      "placeholder": "Buscar nombre"
    },
    "filters": {
      "selectSupplierType": "Seleccionar tipo de proveedor",
      "selectStatus": "Seleccionar estado",
      "selectRiskType": "Seleccionar tipo de riesgo",
      "showOnlyArchived": "Mostrar solo archivados"
    },
    "columns": {
      "name": "Nombre",
      "type": "Tipo",
      "status": "Estado",
      "risk": "Riesgo",
      "sponsor": "Patrocinador",
      "lastModified": "Última modificación",
      "lastAudit": "Última auditoría",
      "dueIn": "Vence en"
    },
    "emptyState": {
      "title": "Aún no tiene proveedores",
      "subtitle": "Antes de agregar un proveedor, se recomienda crear una política de proveedores. La política definirá los tipos de proveedores con los que trabaja, los niveles de riesgo que ayudarán a evaluar a sus proveedores y los tipos de documentos requeridos que cada proveedor necesita tener para ser aprobado.",
      "buttons": {
        "addSupplier": "Agregar proveedor",
        "importSuppliers": "Importar proveedores",
        "configurePolicy": "Configurar política"
      },
      "divider": "o"
    },
    "errors": {
      "noApprovedSuppliers": "No hay proveedores aprobados para exportar",
      "cannotRetrievePolicyLinks": "No se pueden recuperar los enlaces de la política"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "Volver",
      "edit": "Editar",
      "export": "Exportar",
      "archive": "Archivar",
      "unarchive": "Desarchivar",
      "revertToDraft": "Revertir a borrador"
    },
    "tabs": {
      "details": "Detalles",
      "supportingDocuments": "Documentos de respaldo",
      "audits": "Auditorías"
    },
    "sections": {
      "riskLevel": "Nivel de riesgo",
      "generalInfo": "Información general",
      "supplierContactInformation": "Información de contacto del proveedor"
    },
    "fields": {
      "supplierName": "Nombre del proveedor",
      "supplierType": "Tipo de proveedor",
      "website": "Sitio web",
      "intendedUse": "Uso previsto",
      "sponsor": "Patrocinador",
      "approvers": "Aprobadores",
      "createdOn": "Creado el",
      "lastModified": "Última modificación",
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "address": "Dirección",
      "notes": "Notas",
      "contactName": "Nombre",
      "contactEmail": "Correo electrónico",
      "contactPhone": "Teléfono",
      "contactAddress": "Dirección",
      "contactNotes": "Notas"
    },
    "modals": {
      "archive": {
        "title": "Archivar",
        "message": "¿Está seguro de que desea archivar este proveedor? Puede desarchivarlo en cualquier momento.",
        "button": "Archivar"
      },
      "unarchive": {
        "title": "Desarchivar",
        "message": "¿Está seguro de que desea desarchivar este proveedor? El estado cambiará a \"Borrador\".",
        "button": "Desarchivar"
      },
      "revertToDraft": {
        "title": "Revertir a borrador",
        "message": "¿Desea revertir este proveedor al estado de \"Borrador\"?",
        "button": "Revertir"
      },
      "export": {
        "title": "Exportar proveedor",
        "message": "El proveedor se exportará como un archivo zip que contiene:\n- Un archivo PDF con todos los detalles del proveedor\n- Documentos de respaldo\n- Archivos de auditoría",
        "button": "Exportar proveedor"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "Los documentos para este proveedor aparecerán aquí",
      "subtitle": "Si su política de proveedores requiere documentos específicos, edite el proveedor para incluirlos aquí."
    },
    "heading": "Documentos adicionales"
  },
  "supplierAudits": {
    "columns": {
      "name": "Nombre",
      "auditType": "Tipo de auditoría",
      "notes": "Notas",
      "addedBy": "Agregado por",
      "dateCompleted": "Fecha de finalización",
      "dateAdded": "Fecha de creación",
      "documents": "Documentos",
      "filesCount": "{{count}} archivos"
    },
    "menu": {
      "viewDocuments": "Ver documentos",
      "edit": "Edit",
      "delete": "Eliminar"
    },
    "emptyState": {
      "title": "Las auditorías completadas aparecerán aquí",
      "subtitle": "Registre el resultado de auditorías previas con la fecha de finalización, archivos relacionados y notas.",
      "button": "Agregar una auditoría"
    },
    "buttons": {
      "addAudit": "Agregar auditoría"
    },
    "drawer": {
      "noDocuments": "No hay documentos disponibles."
    },
    "modals": {
      "deleteAudit": {
        "title": "Eliminar auditoría",
        "message": "¿Está seguro de que desea eliminar esta auditoría?",
        "buttons": {
          "cancel": "Cancelar",
          "delete": "Eliminar auditoría"
        }
      },
      "addAudit": {
        "title": "Agregar auditoría",
        "buttons": {
          "cancel": "Cancelar",
          "add": "Agregar auditoría"
        }
      },
      "editAudit": {
        "title": "Edit audit",
        "buttons": {
          "cancel": "Cancelar",
          "save": "Save audit"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "La próxima auditoría {{auditType}} vence en {{interval}}",
      "overdueTemplate": "La auditoría {{auditType}} tiene un retraso de {{interval}}",
      "policyRequires": "La política de proveedores requiere que este proveedor sea auditado con una auditoría {{auditType}} cada {{frequency}} mes(es) desde la fecha de la última auditoría ({{lastAuditDate}})",
      "supplierPolicyLink": "política de proveedores"
    }
  },
  "createAuditForm": {
    "heading": "Información de auditoría",
    "fields": {
      "auditName": {
        "label": "Nombre de la auditoría*",
        "error": "Por favor, complete el nombre de la auditoría"
      },
      "auditType": {
        "label": "Tipo de auditoría*",
        "error": "Por favor, complete el tipo de auditoría"
      },
      "notes": {
        "label": "Notas"
      },
      "completionDate": {
        "label": "Fecha de finalización",
        "helper": "La fecha de finalización determina la próxima auditoría programada de este tipo según la política de proveedores.",
        "placeholder": "dd/mm/aaaa"
      }
    },
    "sections": {
      "auditDocuments": "Documentos de auditoría"
    },
    "errors": {
      "fillRequiredFields": "Por favor, complete los campos obligatorios"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "Agregar documento",
      "uploadFromComputer": "Cargar desde la computadora",
      "qualioDoc": "Documento Qualio",
      "download": "Descargar",
      "open": "Abrir",
      "delete": "Eliminar",
      "addDescription": "Agregar descripción"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "No se encontró ningún documento con el prefijo:",
    "placeholder": "Por favor, escriba un prefijo válido de un documento Qualio. Ej: \"POL\""
  },
  "importModal": {
    "title": "Importar proveedores",
    "description": "Si almacena registros de proveedores como documentos Qualio, puede importarlos a la lista de proveedores. Ingrese el prefijo de plantilla de los registros de proveedores",
    "fields": {
      "templatePrefix": {
        "label": "Prefijo de plantilla",
        "helper": "Por ejemplo \"SQF\"",
        "button": "Buscar"
      }
    },
    "messages": {
      "found": "Se encontraron {{count}} registros de proveedores con el prefijo {{prefix}}",
      "notFound": "No se encontraron registros de proveedores con el prefijo {{prefix}}"
    },
    "buttons": {
      "cancel": "Cancelar",
      "import": "Importar"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "Aprobación rechazada",
    "approvalPreviouslyDeclined": "Aprobación rechazada previamente",
    "declinedMessage": "{{name}} rechazó aprobar este proveedor el {{date}} por el siguiente motivo: \"{{reason}}\""
  },
  "statusChangeModal": {
    "approveTitle": "Aprobar proveedor",
    "rejectTitle": "Rechazar proveedor",
    "approveMessage": "Ingrese su contraseña para aprobar este proveedor.",
    "rejectMessage": "Ingrese su contraseña para rechazar este proveedor.",
    "fields": {
      "email": {
        "label": "Correo electrónico",
        "error": "Por favor, ingrese un correo electrónico"
      },
      "password": {
        "label": "Contraseña",
        "error": "Por favor, ingrese una contraseña"
      },
      "reason": {
        "label": "Motivo del rechazo",
        "error": "Por favor, ingrese un motivo para rechazar este proveedor"
      }
    },
    "errors": {
      "fillRequiredFields": "Por favor, complete los campos obligatorios",
      "somethingWentWrong": "Algo salió mal",
      "requiredFields": "Por favor, complete los campos obligatorios",
      "generic": "Algo salió mal",
      "email": "Por favor, ingrese un correo electrónico",
      "password": "Por favor, ingrese una contraseña",
      "reason": "Por favor, ingrese un motivo para rechazar este proveedor"
    },
    "buttons": {
      "cancel": "Cancelar",
      "approve": "Aprobar",
      "reject": "Rechazar"
    }
  },
  "policyConfiguration": {
    "heading": "Configuración de políticas",
    "tabs": {
      "supplierTypes": "Tipos de proveedores",
      "riskLevels": "Niveles de riesgo",
      "documentTypes": "Tipos de documentos",
      "auditTypes": "Tipos de auditorías"
    },
    "template": {
      "title": "Aún no ha definido ningún tipo de revisión",
      "subtitle": "Especifique qué tipos de revisión se utilizarán en la política. Utilice la plantilla sugerida y edítela según sus necesidades o cree una propia.",
      "useTemplate": "Usar definiciones de {{name}} sugeridas",
      "buttons": {
        "useTemplate": "Usar esta plantilla",
        "createFromScratch": "Crear desde cero"
      },
      "divider": "o"
    },
    "configurationCard": {
      "placeholders": {
        "name": "Nombre",
        "addDescription": "Agregar descripción"
      }
    },
    "buttons": {
      "addNew": "Agregar nuevo",
      "cancel": "Cancelar",
      "saveChanges": "Guardar cambios"
    },
    "modals": {
      "saveChanges": {
        "title": "Guardar cambios",
        "message": "Los cambios realizados en los tipos de proveedores afectarán a todos los proveedores existentes de esos tipos. Asegúrese de revisar todos los proveedores afectados y volver a evaluarlos si es necesario.",
        "buttons": {
          "cancel": "Cancelar",
          "save": "Guardar cambios"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "Política de proveedores",
    "buttons": {
      "configuration": "Configuración",
      "edit": "Editar",
      "export": "Exportar"
    },
    "tabs": {
      "requiredDocuments": "Documentos requeridos",
      "audits": "Auditorías"
    },
    "drawer": {
      "title": "Editar política",
      "sections": {
        "supplierType": "Tipo de proveedor",
        "riskLevel": "Nivel de riesgo",
        "requiredDocuments": "Documentos requeridos",
        "audits": "Auditorías"
      },
      "descriptions": {
        "requiredDocuments": "La política requerirá que se agreguen estos documentos para que un proveedor sea aprobado.",
        "audits": "Estas auditorías serán requeridas para todos los proveedores de este tipo y nivel de riesgo."
      },
      "placeholders": {
        "addDocumentType": "Agregar tipo de documento",
        "addAuditType": "Agregar tipo de auditoría",
        "dueEvery": "Vence cada"
      },
      "frequencyOptions": {
        "once": "Una vez",
        "monthsFromLastAudit": "{{count}} mes(es) desde la última auditoría"
      },
      "noTypesFound": "Los tipos {{type}} aún no están definidos en su política de proveedores o ha seleccionado todas las opciones disponibles.",
      "warning": "Los cambios que realice en la política de proveedores afectarán a todos los proveedores existentes de este tipo y nivel de riesgo. Revise todos los proveedores afectados y vuelva a evaluarlos si es necesario.",
      "buttons": {
        "cancel": "Cancelar",
        "save": "Guardar"
      }
    },
    "table": {
      "supplierType": "TIPO DE PROVEEDOR",
      "riskLevel": "NIVEL DE RIESGO"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "Lista de proveedores aprobados (ASL)",
      "generatedBy": "Generado por {{userName}}",
      "generatedWith": "Generado con",
      "qmsFor Life Sciences": "QMS para Life Sciences",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "Nombre del proveedor",
        "type": "Tipo",
        "riskLevel": "Nivel de riesgo",
        "intendedUse": "Uso previsto",
        "lastAudit": "Última auditoría",
        "auditDue": "Auditoría vencida"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "Actualice su plan para acceder a Proveedores",
      "subtitle": "Su plan actual de Qualio no incluye la nueva función de Proveedores. Póngase en contacto con su representante de éxito del cliente para saber cómo actualizar su plan.",
      "button": "Más información sobre Proveedores"
    },
    "insufficientPermissions": {
      "title": "¿Está intentando gestionar la cadena de suministro?",
      "subtitle": "Lamentablemente, actualmente no tiene acceso al módulo de Proveedores. Póngase en contacto con su administrador para que pueda registrar, gestionar y mejorar continuamente su base de proveedores.",
      "button": "Ver vídeo del producto"
    },
    "starterView": {
      "title": "¿Está intentando gestionar la cadena de suministro?",
      "subtitle": "Lamentablemente, actualmente no tiene acceso al módulo de Proveedores. Póngase en contacto con nuestro equipo de soporte para que pueda registrar, gestionar y mejorar continuamente su base de proveedores.",
      "buttons": {
        "contactSupport": "Contactar con el soporte de Qualio",
        "watchVideo": "Ver vídeo del producto"
      }
    }
  },
  "emergencyBreak": {
    "title": "Proveedores está en mantenimiento",
    "subtitle": "Actualmente estamos realizando trabajos de mantenimiento en Proveedores. Tómese un café y vuelva a consultar un poco más tarde. Póngase en contacto si tiene alguna pregunta."
  },
  "notFound": {
    "message": "Parece que está perdido"
  },
  "privateRoute": {
    "unauthorizedTitle": "No tiene permiso para acceder a esto",
    "unauthorizedSubtitle": "Debe haber iniciado sesión como usuario de calidad para ver y editar las políticas de proveedores. Si necesita acceso, póngase en contacto con su equipo de calidad."
  },
  "navigation": {
    "tabs": {
      "supplier": "Proveedor",
      "policy": "Política"
    }
  },
  "statuses": {
    "approved": "Aprobado",
    "pending": "Pendiente",
    "rejected": "Rechazado",
    "draft": "Borrador",
    "archived": "Archivado"
  },
  "toastMessages": {
    "supplier": {
      "archived": "Archivado",
      "archivedDescription": "{{name}} fue archivado",
      "archiveFailed": "Error",
      "archiveFailedDescription": "El proveedor no fue archivado",
      "failure": "Error",
      "notArchived": "Proveedor no archivado",
      "unArchived": "Desarchivado",
      "unArchivedDescription": "{{name}} fue desarchivado",
      "notUnArchived": "El proveedor no fue desarchivado",
      "unarchived": "Desarchivado",
      "unarchivedDescription": "{{name}} fue desarchivado",
      "unarchiveFailed": "Error",
      "unarchiveFailedDescription": "El proveedor no fue desarchivado",
      "reverted": "Revertido",
      "revertedDescription": "{{name}} fue revertido a borrador",
      "revertedToDraftDescription": "{{name}} fue revertido a borrador",
      "notRevertedToDraft": "El proveedor no fue revertido a borrador",
      "revertFailed": "Error",
      "revertFailedDescription": "El proveedor no fue revertido a borrador",
      "saved": "Guardado",
      "savedAsDraft": "{{name}} se guardó como borrador.",
      "savedAsDraftDescription": "{{name}} se guardó como borrador.",
      "notSavedAsDraft": "El proveedor no se guardó como borrador",
      "notSentForApproval": "El proveedor no se envió para aprobación",
      "sent": "Enviado",
      "sentForApproval": "{{name}} se envió para aprobación",
      "sentForApprovalDescription": "{{name}} se envió para aprobación",
      "saveFailed": "Error",
      "saveFailedDescription": "El proveedor no se guardó como borrador.",
      "fileReady": "Archivo listo",
      "fileReadyDescription": "El archivo ya está disponible para",
      "download": "descargar",
      "exportFailed": "Error",
      "exportFailedDescription": "Proveedor no exportado",
      "notExported": "Proveedor no exportado",
      "revertedToDraft": "{{name}} fue revertido a borrador",
      "revertToDraftFailed": "El proveedor no fue revertido a borrador",
      "preparingFile": "Preparando archivo para la descarga",
      "preparingFileDescription": "Le avisaremos cuando el archivo esté listo",
      "exportsFailed": "Los proveedores no fueron exportados",
      "suppliersNotExported": "Los proveedores no fueron exportados"
    },
    "audit": {
      "added": "Auditoría agregada",
      "creationFailed": "Error al crear la auditoría",
      "creationFailedDescription": "No se pudo adjuntar la auditoría al proveedor",
      "updated": "Audit updated",
      "updateFailed": "Audit update failed",
      "updateFailedDescription": "Failed to update the audit",
      "deleted": "Auditoría eliminada",
      "deletionFailed": "Error al eliminar la auditoría",
      "deletionFailedDescription": "No se pudo eliminar la auditoría del proveedor"
    },
    "config": {
      "configuration": "Configuración",
      "updated": "{{configType}} fue actualizado",
      "updateFailed": "Error al actualizar la configuración"
    },
    "policy": {
      "saved": "Política guardada",
      "savedDescription": "Es posible que deba volver a evaluar a los proveedores afectados.",
      "saveFailed": "Error",
      "saveFailedDescription": "No se puede guardar su política."
    },
    "policyLinks": {
      "fetchFailed": "Algo salió mal al obtener los documentos de respaldo requeridos"
    },
    "import": {
      "success": "Importación exitosa",
      "successDescription": "Los proveedores se han importado correctamente",
      "failed": "Error en la importación",
      "failedDescription": "Error al importar los proveedores"
    },
    "approval": {
      "completed": "Acción de aprobación completada"
    },
    "document": {
      "downloadError": "Error",
      "downloadErrorDescription": "Ocurrió un error al descargar este documento"
    },
    "export": {
      "error": "Error",
      "errorDescription": "No hay proveedores aprobados para exportar",
      "policyLinksError": "No se pueden recuperar los enlaces de la política",
      "supplierExportToast": "Exportación de {{name}}",
      "configExportToast": "Exportación de configuración de proveedores"
    }
  },
  "common": {
    "buttons": {
      "cancel": "Cancelar",
      "save": "Guardar",
      "delete": "Eliminar",
      "edit": "Editar",
      "close": "Cerrar",
      "review": "Revisar",
      "ok": "Aceptar",
      "gotIt": "Entendido"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "eliminar-descripción",
      "downloadFile": "Descargar archivo",
      "openQualioDoc": "Abrir documento Qualio",
      "deleteFile": "Eliminar archivo",
      "deletePolicyRow": "Eliminar fila de política",
      "viewRelatedRecords": "Ver registros relacionados"
    },
    "misc": {
      "auditType": "Tipo de auditoría:",
      "name": "Nombre:",
      "type": "Tipo:"
    }
  }
}
